import React from 'react';
import * as S from './Radio.styles';

interface RadioProps {
  isChecked: boolean;
  onClick?: (a: boolean) => void;
  disabled?: boolean;
  small?: boolean;
  medium?: boolean;
  dataCy?: string;
}

const Radio: React.FC<RadioProps> = ({ isChecked, onClick, disabled, small, medium, dataCy = 'radio' }) => {
  return (
    <S.Div
      $isChecked={isChecked}
      onClick={onClick ? () => onClick(!isChecked) : undefined}
      $disabled={disabled}
      $small={small}
      $medium={medium}
      data-cy={dataCy}
    >
      {!isChecked && <div className="is-checked"></div>}
    </S.Div>
  );
};

export default Radio;
